
export const LightTheme = {
    header: '#350d36',
    sidebar: '#3F0E40',
    msg: '#f8f8f8',
    msgText: 'black',
    border: '#532753',
    sendArea: 'white'
}

export const DarkTheme = {
    header: '#2f2f2f',
    sidebar: '#2f2f2f',
    msg: '#2f2f2f',
    msgText: '#e4e4e4',
    border: '#484848',
    sendArea: '#333'
}